import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';

class ScrollItem__WidgetProjects extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);
    }
}

Scroll._registerClass('WidgetProjects', ScrollItem__WidgetProjects);

export default ScrollItem__WidgetProjects;
